import React, { JSX } from 'react';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';

type DisclaimerWidgetProps = StyleguideComponentProps & {
  fields: {
    body: Field<string>;
  };
};

const DisclaimerWidget = (props: DisclaimerWidgetProps): JSX.Element => {
  const { fields } = props;
  return (
    <div
      className="text-banner"
      id={`disclaimer-widget-${props.rendering?.uid}`}
    >
      <RichText field={fields?.body || ''} />
    </div>
  );
};
export default DisclaimerWidget;
